import { Compass } from 'lucide-react';
import { Link } from 'react-router-dom';
import { EmptyState } from '@/components/EmptyState';
import { Page } from '@/components/Page';
import { Button } from '@/components/ui/button';

export function NotFoundPage(): JSX.Element {
  return (
    <Page width="2xl">
      <EmptyState
        variant="page"
        icon={Compass}
        titleAs="h1"
        title="Page not found"
        hint="The page you are looking for does not exist."
        action={
          <Button asChild variant="ghost">
            <Link to="/">Go to Dashboard</Link>
          </Button>
        }
      />
    </Page>
  );
}
